import { render, staticRenderFns } from "./DialogAddClient.vue?vue&type=template&id=32d1d98e"
import script from "./DialogAddClient.vue?vue&type=script&lang=js"
export * from "./DialogAddClient.vue?vue&type=script&lang=js"
import style0 from "./DialogAddClient.vue?vue&type=style&index=0&id=32d1d98e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports